import React, { useState } from "react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "../components/ui/tabs";
import { FileText, TrendingUp } from "lucide-react";
import QuotesList from "./QuotesList";
import MassQuoteUpdate from "./MassQuoteUpdate";

const QuotesWithMassUpdate = () => {
  const [activeTab, setActiveTab] = useState("quotes");

  return (
    <div className="space-y-6">
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full max-w-md grid-cols-2">
          <TabsTrigger value="quotes" data-testid="tab-quotes">
            <FileText className="h-4 w-4 mr-2" />
            Quotes
          </TabsTrigger>
          <TabsTrigger value="mass-update" data-testid="tab-mass-update">
            <TrendingUp className="h-4 w-4 mr-2" />
            Mass Update
          </TabsTrigger>
        </TabsList>

        <TabsContent value="quotes" className="mt-6">
          <QuotesList />
        </TabsContent>

        <TabsContent value="mass-update" className="mt-6">
          <MassQuoteUpdate />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default QuotesWithMassUpdate;
